import React, { useState, useEffect } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import authService from '../../core/services/AuthService';

/**
 * UserAuth component displays user authentication status and controls
 */
const UserAuth = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [userInfo, setUserInfo] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const authenticated = await authService.checkAuthentication();
                setIsAuthenticated(authenticated);
                
                if (authenticated) {
                    const user = authService.getCurrentUser();
                    setUserInfo(user);
                }
            } catch (error) {
                console.error('Error checking authentication:', error);
            } finally {
                setLoading(false);
            }
        };

        checkAuth();
    }, []);

    const handleLogin = () => {
        authService.login();
    };

    const handleLogout = () => {
        // Redirect to Achmea website after logout to prevent auto-login loop
        window.location.href = '/.auth/logout?post_logout_redirect_uri=https://www.achmea.com.au/';
    };

    if (loading) {
        return (
            <div className="d-flex align-items-center">
                <span className="text-light small">Loading...</span>
            </div>
        );
    }

    if (!isAuthenticated) {
        // Check if authentication is disabled via environment variable
        const isAuthDisabled = process.env.REACT_APP_DISABLE_AUTH === 'true';
        console.log('isAuthDisabled', isAuthDisabled);
        // If auth is disabled, don't show login button (anonymous access)
        if (isAuthDisabled) {
            return null;
        }
        
        // If auth is enabled, show login button
        return (
            <Button 
                variant="outline-light" 
                onClick={handleLogin}
                className="btn-navigation"
            >
                <i className="bi bi-person-circle me-2"></i>
                SIGN IN
            </Button>
        );
    }

    const userEmail = authService.getUserEmail();
    const displayName = userEmail ? userEmail.split('@')[0] : 'User';

    return (
        <Dropdown align="end">
            <Dropdown.Toggle 
                variant="outline-light" 
                id="user-dropdown"
                className="btn-navigation user-dropdown-toggle"
                style={{
                    border: 'none',
                    background: 'rgba(179, 204, 218, 0.4)',
                    color: 'white',
                    textTransform: 'none',
                    fontWeight: '500'
                }}
            >
                <i className="bi bi-person-circle me-2"></i>
                {displayName}
                <i className="bi bi-chevron-down ms-2" style={{ fontSize: '0.75rem' }}></i>
            </Dropdown.Toggle>

            <Dropdown.Menu 
                className="user-dropdown-menu"
                style={{
                    minWidth: '200px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    border: '1px solid rgba(0,0,0,0.1)',
                    borderRadius: '8px',
                    padding: '0.5rem 0'
                }}
            >
                <div className="px-3 py-2 border-bottom">
                    <div className="text-muted small" style={{ fontSize: '0.75rem' }}>Signed in as:</div>
                    <div className="fw-bold text-dark" style={{ fontSize: '0.85rem' }}>{userEmail}</div>
                </div>
                <Dropdown.Item 
                    onClick={handleLogout}
                    className="d-flex align-items-center py-2 px-3"
                    style={{
                        fontSize: '0.85rem',
                        transition: 'background-color 0.2s ease'
                    }}
                >
                    <i className="bi bi-box-arrow-right me-2 text-danger"></i>
                    Sign Out
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default UserAuth; 